import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m12 18.768 7.416 4.375-1.968-8.2457 6.552-5.548-8.628-.71547-3.372-7.7765-3.372 7.7765-8.628.71547 6.552 5.548-1.968 8.2457z",
		fill: "currentColor",
		strokeWidth: 1.7143
	})]
});
const ForwardRef = forwardRef(SvgStarFilled);
export { ForwardRef as ReactComponent };
